import { useState, useRef, useEffect } from 'react';

interface Props {
    folderId: number;
    initialName: string;
    onClose: () => void;
    onSubmit: (id: number, name: string) => Promise<void>;
}

const EditFolderModal = ({ folderId, initialName, onClose, onSubmit }: Props) => {
    const [name, setName] = useState(initialName);
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.select();
            inputRef.current.focus({ preventScroll: true });
        }
    }, []);

    const handleSubmit = async (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        const trimmed = name.trim();
        if (!trimmed || trimmed === initialName) {
            if (trimmed === initialName) onClose();
            return;
        }

        setIsLoading(true);
        try {
            await onSubmit(folderId, trimmed);
            onClose();
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal card modal-sm modal-premium" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="close-btn" onClick={onClose}>✕</button>

                <div className="modal-content-wrapper">
                    <form onSubmit={handleSubmit}>
                        <h2>Renommer le dossier</h2>

                        <div style={{ marginTop: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <label className="input-label" htmlFor="folder-name-edit" style={{ fontWeight: 500, color: 'var(--text)' }}>
                                Nouveau nom
                            </label>
                            <input
                                ref={inputRef}
                                id="folder-name-edit"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Nom du dossier"
                                className="input-premium"
                                disabled={isLoading}
                                maxLength={50}
                            />
                        </div>

                        <div className="modal-actions">
                            <button
                                type="button"
                                className="ghost-button"
                                onClick={onClose}
                                disabled={isLoading}
                            >
                                Annuler
                            </button>
                            <button
                                type="submit"
                                className="primary"
                                disabled={!name.trim() || name === initialName || isLoading}
                            >
                                {isLoading ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditFolderModal;
